import React from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";

const getStyles = (theme) => {
  const isLight = theme === "light";

  return {
    control: (base, state) => ({
      ...base,
      backgroundColor: isLight ? "#fff" : "#282828",
      borderColor: state.selectProps.isInvalid
        ? "#dc3545"
        : isLight
        ? "#ced4da"
        : "#282828",
      padding: "8px 4px",
      borderRadius: "3px",
      boxShadow: "none",
      "&:hover": {
        borderColor: state.selectProps.isInvalid
          ? "#dc3545"
          : isLight
          ? "#ced4da"
          : "#282828",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: isLight ? "#000" : "#fff",
      fontStyle: "italic",
      textTransform: "uppercase",
      fontSize: "11px",
    }),
    placeholder: (base) => ({
      ...base,
      color: isLight ? "#6c757d" : "#fff",
      fontStyle: "italic",
      textTransform: "uppercase",
      fontSize: "11px",
    }),
    input: (base) => ({
      ...base,
      color: isLight ? "#000" : "#fff",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: isLight ? "#fff" : "#282828",
      zIndex: 20,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? "#946D42"
        : isLight
        ? "#fff"
        : "#282828",
      color: state.isFocused ? "#fff" : isLight ? "#000" : "#fff",
      fontStyle: "italic",
      cursor: "pointer",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#946D42",
    }),
  };
};

const CustomSelect = ({
  formik,
  name,
  options,
  placeholder,
  errorNamespace,
  theme = "dark",
  ...rest
}) => {
  const errorKey = errorNamespace || name;
  const isInvalid = !!(formik.touched[name] && formik.errors[errorKey]);

  const selectedOption =
    options.find((opt) => opt.value === formik.values[name]) || null;

  return (
    <>
      <Select
        name={name}
        options={options}
        placeholder={placeholder}
        value={selectedOption}
        onChange={(selected) => {
          const value = selected ? selected.value : "";
          formik.setFieldValue(name, value, true);
          formik.setFieldTouched(name, true, false);
        }}
        styles={getStyles(theme)}
        isInvalid={isInvalid}
        classNamePrefix="rs"
        {...rest}
      />
      {isInvalid && (
        <Form.Text className="text-danger d-block mt-1" style={{ fontSize: "0.875em" }}>
          {formik.errors[errorKey]}
        </Form.Text>
      )}
    </>
  );
};

export default CustomSelect;